import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedTextProps {
  children: string;
  className?: string;
  delay?: number;
  duration?: number;
  splitBy?: 'word' | 'char';
}

export const AnimatedText: React.FC<AnimatedTextProps> = ({
  children,
  className = '',
  delay = 0,
  duration = 0.5,
  splitBy = 'word'
}) => {
  const words = children.split(' ');
  const chars = children.split('');

  if (splitBy === 'char') {
    return (
      <motion.span className={className}>
        {chars.map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: duration,
              delay: delay + (index * 0.02),
              ease: [0.6, 0.01, 0.05, 0.95]
            }}
            style={{ display: 'inline-block' }}
          >
            {char === ' ' ? '\u00A0' : char}
          </motion.span>
        ))}
      </motion.span>
    );
  }

  return (
    <motion.span className={className}>
      {words.map((word, index) => (
        <React.Fragment key={index}>
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: duration,
              delay: delay + (index * 0.08),
              ease: [0.6, 0.01, 0.05, 0.95]
            }}
            style={{ display: 'inline-block' }}
          >
            {word}
          </motion.span>
          {index < words.length - 1 && <span> </span>}
        </React.Fragment>
      ))}
    </motion.span>
  );
};
